import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { gameTypes } from 'config/promoGameTypes';
import { scrollPromoBodyIntoView } from 'client/utils/scroll';
import useClientHistory, { JOIN } from 'client/hooks/useClientHistory';
import { replayGame } from 'client/redux/modules/userEntryState';

const Survey = lazy(() =>
    import(/* webpackChunkName: "result_survey" */ 'client/game_survey/CustomResultSection')
);
const Quiz = lazy(() =>
    import(/* webpackChunkName: "result_quiz" */ 'client/game_quiz/CustomResultSection')
);
const PsychoQuiz = lazy(() =>
    import(/* webpackChunkName: "result_psychoquiz" */ 'client/game_psychoQuiz/CustomResultSection')
);
const Vote = lazy(() =>
    import(/* webpackChunkName: "result_vote" */ 'client/game_vote/CustomResultSection')
);
const MemoryMatch = lazy(() =>
    import(
        /* webpackChunkName: "result_memory_match" */ 'client/game_memoryMatch/CustomResultSection'
    )
);
const SignUp = lazy(() =>
    import(/* webpackChunkName: "result_sign_up" */ 'client/game_signUp/CustomResultSection')
);

const Results = {
    [gameTypes.PSYCHO_QUIZ]: PsychoQuiz,
    [gameTypes.QUIZ]: Quiz,
    [gameTypes.SURVEY]: Survey,
    [gameTypes.VOTE]: Vote,
    [gameTypes.MEMORY_MATCH]: MemoryMatch,
    [gameTypes.SIGN_UP]: SignUp
};

export default function CustomResult({ page, result, gameResult, latestRecord }) {
    const dispatch = useDispatch();
    const history = useClientHistory();
    const { type } = useSelector(s => s.promo);
    const { loginMethod } = useSelector(s => s.settingPromo);
    const Result = Results[type];

    function handleReplay() {
        dispatch(replayGame());
        scrollPromoBodyIntoView();
        history.push(JOIN);
    }

    return (
        Boolean(Result) && (
            <Result
                page={page}
                result={result}
                loginMethod={loginMethod}
                onReplay={handleReplay}
                gameResult={gameResult}
                latestRecord={latestRecord}
            />
        )
    );
}

CustomResult.propTypes = {
    page: PropTypes.object,
    result: PropTypes.object
};
